import {getApiConfig} from '../../config/api.config';
import {authenticatedFetch} from '../../features/auth/AuthenticatedService';

export class HealthIdentifierService{

    public static get baseUrl() {
        return getApiConfig().url.healthIdentifier.replace(/\/+$/, "");
    }

    public static async AsyncPost(path: string, data: any) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        };

        let url = `${this.baseUrl}${path}`;

        try{
            let response = await authenticatedFetch(url, requestOptions);
            return await response.json();
        }
        catch{
            //Handle the case where the HealthIdentifier API was not available or errored
            return null;
        }

    }
}